import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * The active tab lives in `?tab=` so deep links work and the URL never
 * desyncs from the visible tab. Unknown values fall back to `fallback`.
 */
export function useTabParam<T extends string>(
  tabs: readonly T[],
  fallback: T,
): [tab: T, setTab: (next: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const tab = tabs.includes(tabParam as T) ? (tabParam as T) : fallback
  const setTab = useCallback(
    (next: T) =>
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev)
          params.set('tab', next)
          return params
        },
        { replace: true },
      ),
    [setSearchParams],
  )
  return [tab, setTab]
}
